// extracted by mini-css-extract-plugin
module.exports = {"container":"Video-module--container--19t4I","overlay":"Video-module--overlay--172Zl","actionIcon":"Video-module--actionIcon--1og3n"};